<template>
    <div class="explanation-container">
        <div class="scenario-context">
            <div class="customer-action-card">
                <div class="d-flex align-center justify-center flex-wrap gap-2 mb-2">
                    <v-icon
                        color="success"
                        size="24"
                        aria-hidden="true"
                    >
                        mdi-check-circle
                    </v-icon>
                    <h4 class="text-h6">
                        A new customer just placed an order on your site!
                    </h4>
                </div>
                <p class="mb-1"><strong>Name:</strong> {{ order_data.first_name }} {{ order_data.last_name }}</p>
                <p class="mb-1"><strong>Delivery Method:</strong> {{ order_data.delivery_method }}</p>
                <p class="mb-1"><strong>Phone:</strong> {{ order_data.phone }}</p>

                <p class="demo-note text-left mt-4">
                    NOTE: The process shown in this demo will only apply to those who <strong>do not</strong> already
                    have consent on file in RedChirp.
                </p>
            </div>
        </div>

        <div>
            <h3 class="text-h5 text-left mb-3">Here's what happens next ...</h3>
            <div class="explanation-points">
                <div
                    class="explanation-point"
                    v-for="(point, idx) in explanationPoints"
                    :key="idx"
                >
                    <v-icon
                        color="primary"
                        size="28"
                        class="point-icon"
                        aria-hidden="true"
                    >
                        mdi-chevron-right
                    </v-icon>
                    <p class="point-text">{{ point }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        order_data: {
            type: Object,
            required: true
        }
    },
    computed: {
        explanationPoints() {
            const nickname = this.order_data?.customer_nickname || 'the customer';
            return [
                `RedChirp detects that ${nickname} does not have consent on file, as indicated by the phone number she provided when placing her order`,
                `An automated SMS is sent to ${nickname}, indicating that she needs to confirm the order details. Since this is a transactional message (not marketing), no prior consent is required`,
                `The text message provides a link to a secure web page where she can review and confirm her order details`
            ];
        }
    }
}
</script>

<style lang="scss" scoped>
.explanation-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 2rem;
    align-items: center;
    padding: 2rem;

    @media (max-width: 900px) {
        padding: .5rem 0;
    }

    .scenario-context {
        max-width: 500px;
        margin: 0 auto;

        @media (min-width: 900px) {
            margin: 0;
            max-width: none;
        }
    }

    .customer-action-card {
        background: #f8f9fa;
        border: 2px solid #e9ecef;
        border-radius: 12px;
        padding: 1.5rem;
        text-align: center;

        p {
            margin: 0;
            color: #495057;
            font-size: 0.95rem;
        }

        h4 {
            color: #28a745;
            margin: 0;
        }
    }
}
</style>
